module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point3_5-a48d8205eb2301f2c085c7ea5b6cae14.jpg";